import React, { useRef } from "react";
import LeftSideBox from "../LeftSideBox";
import FilePreviewGrid from "./FilePreviewGrid";
import getPDFPageCount from "../../methods/getPDFPageCount";

export default function PDFFilesProcess({
  files,
  setFiles,
  sortableFilePreviewGrid,
  addFileOptions,
  downloadHandler,
  LeftSideBoxExtra,
  FilePreviewExtra,
}) {
  const inputButtonRef = useRef(null);

  const handleDeleteFile = (e) => {
    e.preventDefault();

    setFiles([]);
  };

  const handleAddFileButtonClick = () => {
    inputButtonRef.current.click();
  };

  const onFileChange = async (e) => {
    const newFiles = Array.from(e.target.files);
    const temp = [];

    for (let i = 0; i < newFiles.length; i++) {
      const file = await newFiles[i];
      file.pageCount = await getPDFPageCount(file);
      await temp.push(file);
    }

    await setFiles([...files, ...temp]);
  };

  return (
    <div className="overflow-x-hidden">
      <input
        type="file"
        className="hidden"
        accept={addFileOptions.fileType}
        ref={inputButtonRef}
        multiple={addFileOptions.multiple}
        onChange={onFileChange}
      />

      <div className="px-4 py-6 md:px-24 md:py-12 flex flex-col items-center md:items-start">
        <button
          className="md:w-1/3 w-full bg-amber-200 px-8 py-4 rounded-sm text-xl"
          onClick={downloadHandler}
        >
          Save And Download
        </button>

        <div className="flex flex-col md:flex-row w-full justify-between mt-6">
          <LeftSideBox
            handleAddFileButtonClick={handleAddFileButtonClick}
            handleDeleteFilesClick={handleDeleteFile}
            multiple={addFileOptions.multiple}
          >
            {LeftSideBoxExtra && <LeftSideBoxExtra />}
          </LeftSideBox>

          <div className="w-full md:w-2/3 p-4 border-amber-200 border-2 border-dashed">
            <FilePreviewGrid
              files={files}
              setFiles={setFiles}
              FilePreviewExtra={FilePreviewExtra}
              sortableFilePreviewGrid={sortableFilePreviewGrid}
              LeftSideBoxExtra={LeftSideBoxExtra}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
